/* ============================================================
   BeyGamer — TECH layer JS (2026-10-18)
   - Variant picker really selects the variant (before: the first variant was always added)
   - Buy Now: add the chosen variant + quantity, go straight to checkout
   - Sticky buy bar follows the shopper once the main buy button scrolls away
   ============================================================ */
(function () {
  'use strict';
  var form = document.querySelector('[data-product-form]');
  var dataEl = document.getElementById('ProductVariantsJSON');
  if (!form || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || [];
  var select = form.querySelector('[data-variant-select]');
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  function selectedOptions() {
    var picked = [];
    form.querySelectorAll('[data-option-selector]:checked').forEach(function (input) {
      picked[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
    });
    return picked;
  }

  function currentVariant() {
    var id = select ? parseInt(select.value, 10) : null;
    return variants.find(function (v) { return v.id === id; }) || variants[0];
  }

  function render(v) {
    if (!v) return;
    document.querySelectorAll('[data-variant-price], [data-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
    var compare = document.querySelector('[data-variant-compare]');
    if (compare) {
      if (v.compare > v.price) { compare.textContent = money(v.compare); compare.hidden = false; } else { compare.hidden = true; }
    }
    var stock = document.querySelector('[data-variant-stock]');
    if (stock) stock.hidden = !v.available;
    var label = document.querySelector('[data-sticky-variant]');
    if (label) label.textContent = v.title;
    document.querySelectorAll('[data-add-to-cart], [data-buy-now]').forEach(function (btn) { btn.disabled = !v.available; });
    var add = form.querySelector('[data-add-to-cart]');
    if (add) add.textContent = v.available ? 'Add to Cart' : 'Sold Out';
    if (v.image) {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = v.image;
    }
  }

  function onOptionChange() {
    var picked = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return picked[i] === undefined || picked[i] === opt; });
    });
    if (match && select) select.value = String(match.id);
    render(match);
  }
  form.querySelectorAll('[data-option-selector]').forEach(function (input) { input.addEventListener('change', onOptionChange); });
  if (form.querySelector('[data-option-selector]')) onOptionChange();

  /* Buy Now: straight to checkout with the chosen variant and quantity */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var old = btn.textContent;
      document.querySelectorAll('[data-buy-now]').forEach(function (b) { b.disabled = true; b.textContent = 'Loading...'; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        document.querySelectorAll('[data-buy-now]').forEach(function (b) { b.disabled = false; b.textContent = old; });
      });
    });
  });

  /* Sticky bar: visible while the main buy area is above the viewport */
  var bar = document.querySelector('[data-sticky-buy]');
  var anchor = form.querySelector('.product__buy');
  if (bar && anchor) {
    var shown = null;
    var update = function () {
      var show = anchor.getBoundingClientRect().bottom < 0;  // the main buy buttons are above the screen
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-buy', show);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
})();
